export default __webpack_public_path__ + "static/media/loading.bd0bfe09.gif";